<template>
  <div class="right_box_main">
    <div class="listBox-item">
      <!-- 表格 -->
      <el-card>
        <!-- 搜索框 -->
        <div>
          <el-form
            :inline="true"
            :model="searchlist"
            class="demo-form-inline"
          >
            <el-form-item label="时间">
              <el-date-picker
                v-model="searchlist.time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input
                v-model="searchlist.personName"
                placeholder
              ></el-input>
            </el-form-item>
            <el-form-item
              label="所属机构"
              prop="orgName"
            >
              <el-cascader
                v-model="searchlist.orgId"
                :options="orgList"
                @change="handleChange"
                :show-all-levels="false"
              ></el-cascader>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="searchlistdata"
              >查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="info"
                @click="searchlistReset"
              >重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 表格主体 -->
        <div class="listBox-item">
          <div class="table_card">
            <el-table
              :data="tableData"
              :header-cell-style="{ background: '#f8fafa' }"
              size="small"
              border
              align="center"
              current-row-key
              highlight-current-row
            >
              <!-- <el-table-column align="center" type="selection" width="35"></el-table-column> -->
              <el-table-column
                align="center"
                prop="personName"
                label="用户名"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="orgName"
                label="组织机构"
              ></el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              :page-size="pageConfig.pageSize"
              layout="total, prev, pager, next, jumper"
              @current-change="handleCurrentChange"
              :total="pageConfig.total"
            ></el-pagination>
            <!-- <el-button type="primary">确定</el-button>
            <el-button type="info">取消</el-button>-->
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import { post } from "@/api/requrestHttp"
// 表格数据和分页js
import { tabdata } from "@/mixins/tabledataMix.js"
// 表单校验js
import { validatePhoneOrMobile } from "@/utils/validate.js"
export default {
  mixins: [tabdata],
  data() {
    return {
      searchlist: {
        // applyName: "",
        // approvalStatus: "",
        // time: []
        orgId: [],
      },
      orgList: [],
      tableData: [],
      tableDataUrl: "",
      // 审核弹框显示隐藏
      examineDialogVisible: false,
      // 重新赋值需要绑定
      examine: {
        approvalStatus: "",
        applyType: "",
      },
      applyTypeList: [],
    }
  },
  methods: {
    // 所属机构
    handleChange(value) {
      if (value != null) {
        this.orgId = value[value.length - 1]
      }
    },
  },
  created() {
    post("/rbac/admin/org/info/OrgTreelist", { orgType: 1,isValid: 1, }).then((res) => {
      this.orgList = res.content
    })
  },
  mounted() {},
}
</script>

<style scoped>
img.tbImg {
  width: 20px;
  height: 20px;
}

img.tbImgTwo {
  width: 40px;
  height: 40px;
}
</style>
